import Vue from "vue";
import Vuex from "vuex";
import * as d3 from "d3";
import axios from "axios";
//import * as _ from "lodash";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    filters: {
      state: "",
      order: "",
      searchText: "",
      type: "",
      context: "",
      period: [2017, 2018],
      minYear: "",
      maxYear: "",
    },
    contexts: [],
    bakContexts: [],
    min: 2017,
    max: 2018,
    years: [],
    reports: [],
    filteredReports: [],
    bakReports: [],
    selection: undefined,
    aggressionsTypes: [
      {
        slug: "allanamiento",
        title: "Allanamiento",
        color: "#603813",
        subtypes: [
          {
            slug: "allanamiento-de-hogares",
            title: "Allanamiento de hogares",
          },
          {
            slug: "allanamiento-de-oficinas",
            title: "Allanamiento de oficinas",
          },
          {
            slug: "allanamiento-de-hogares-con-connotacion-sexual",
            title: "Allanamiento de hogares con connotación sexual",
          },
          {
            slug: "allanamiento-de-hogares-con-componente-de-genero",
            title: "Allanamiento de hogares con componente de género",
          },
          {
            slug: "allanamiento-de-oficinas-con-connotacion-sexual",
            title: "Allanamiento de oficinas con connotación sexual",
          },
          {
            slug: "allanamiento-de-oficinas-con-componente-de-genero",
            title: "Allanamiento de oficinas con componente de género",
          },
        ],
      },
      {
        slug: "amenaza",
        title: "Amenaza",
        color: "#C1272D",
        subtypes: [
          {
            slug: "de-muerte",
            title: "De muerte",
          },
          {
            slug: "a-la-integridad-de-la-persona",
            title: "A la integridad de la persona",
          },
          {
            slug: "al-medio-de-comunicacion",
            title: "Al medio de comunicación",
          },
          {
            slug: "a-familiares-o-amistades",
            title: "A familiares o amistades",
          },
          {
            slug: "de-desaparicion",
            title: "De desaparición",
          },
          {
            slug: "de-acciones-legales",
            title: "De acciones legales",
          },
          {
            slug: "de-violencia-sexual",
            title: "De violencia sexual",
          },
          {
            slug: "con-componente-de-genero",
            title: "Con componente de género",
          },
        ],
      },
      {
        slug: "asesinato",
        title: "Asesinato",
        color: "#4A4A4A",
        subtypes: [
          {
            slug: "homicidio",
            title: "Homicidio",
          },
          {
            slug: "feminicidio",
            title: "Feminicidio",
          },
          {
            slug: "crimen-de-odio",
            title: "Crimen de odio",
          },
          {
            slug: "ejecucion-extrajudicial",
            title: "Ejecución extrajudicial",
          },
        ],
      },
      {
        slug: "ataque-a-bienes-materiales",
        title: "Ataque a bienes materiales",
        color: "#6D92E2",
        subtypes: [
          {
            slug: "dano-o-destruccion-de-equipo-o-material-de-trabajo",
            title: "Daño o destrucción de equipo o material de trabajo",
          },
          {
            slug:
              "dano-o-destruccion-de-bienes-muebles-que-no-son-material-de-trabajo",
            title:
              "Daño o destrucción de bienes muebles que no son material de trabajo",
          },
          {
            slug:
              "dano-o-destruccion-de-bienes-muebles-con-componente-de-genero",
            title:
              "Daño o destrucción de bienes muebles con componente de género",
          },
          {
            slug:
              "dano-o-destruccion-de-bienes-inmuebles-con-connotacion-sexual",
            title:
              "Daño o destrucción de bienes inmuebles con connotación sexual",
          },
          {
            slug: "robo-de-equipo-o-material-de-trabajo",
            title: "Robo de equipo o material de trabajo",
          },
          {
            slug: "robo-de-bienes-muebles-que-no-son-material-de-trabajo",
            title: "Robo de bienes muebles que no son material de trabajo",
          },
          {
            slug: "robo-de-bienes-inmuebles-con-componente-de-genero",
            title: "Robo de bienes inmuebles con componente de género",
          },
          {
            slug: "robo-de-bienes-muebles-con-connotacion-sexual",
            title: "Robo de bienes muebles con connotación sexual",
          },
          {
            slug: "al-domicilio",
            title: "Al domicilio",
          },
          {
            slug: "al-domicilio-con-componente-de-genero",
            title: "Al domicilio con componente de género",
          },
          {
            slug: "al-domicilio-con-connotacion-sexual",
            title: "Al domicilio con connotación sexual",
          },
        ],
      },
      {
        slug: "ataque-a-redes-comunicaciones-digitales-y-sistemas-informaticos",
        title:
          "Ataque a redes, comunicaciones digitales y sistemas informáticos",
        color: "#F7931E",
        subtypes: [
          {
            slug: "interrupcion-de-servicios-de-internet",
            title: "Interrupción de servicios de internet",
          },
          {
            slug: "dominios-falsos-o-cuentas-falsas",
            title: "Dominios falsos o cuentas falsas",
          },
          {
            slug: "dominios-falsos-o-cuentas-falsas-con-componente-de-genero",
            title: "Dominios falsos o cuentas falsas con componente de género",
          },
          {
            slug: "dominios-falsos-o-cuentas-falsas-con-connotacion-sexual",
            title: "Dominios falsos o cuentas falsas con connotación sexual",
          },
          {
            slug: "denegacion-de-servicio-dos-ddos",
            title: "Denegación de servicio (DOS, DDOS)",
          },
        ],
      },
      {
        slug: "ataque-fisico",
        title: "Ataque físico",
        color: "#D4E25F",
        subtypes: [
          {
            slug: "tentativa-de-asesinato",
            title: "Tentativa de asesinato",
          },
          {
            slug: "lesiones",
            title: "Lesiones",
          },
          {
            slug: "lesiones-con-componente-de-genero",
            title: "Lesiones con componente de género",
          },
          {
            slug: "violencia-sexual",
            title: "Violencia sexual",
          },
        ],
      },
      {
        slug: "bloqueo-alteracion-o-remocion-de-informacion",
        title: "Bloqueo, alteración o remoción de información",
        color: "#22B6B0",
        subtypes: [
          {
            slug: "bloqueo-informativo",
            title: "Bloqueo informativo",
          },
          {
            slug: "bloqueo-informativo-por-razones-de-genero",
            title: "Bloqueo informativo por razones de género",
          },
          {
            slug: "remocion-de-contenido",
            title: "Remoción de contenido",
          },
          {
            slug: "compra-o-robo-masivo-de-publicaciones",
            title: "Compra o robo masivo de publicaciones",
          },
          {
            slug: "coercion-para-publicar-informacion",
            title: "Coerción para publicar información",
          },
          {
            slug: "alteracion-de-contenido",
            title: "Alteración de contenido",
          },
          {
            slug:
              "alteracion-o-falsificacion-de-contenido-con-componente-de-genero",
            title:
              "Alteración o falsificación de contenido con componente de género",
          },
          {
            slug:
              "alteracion-o-falsificacion-de-contenido-con-connotacion-sexual",
            title:
              "Alteración o falsificación de contenido con connotación sexual",
          },
        ],
      },
      {
        slug: "desaparicion",
        title: "Desaparición",
        color: "#CCCCCC",
        subtypes: [
          {
            slug: "forzada",
            title: "Forzada",
          },
          {
            slug: "por-particulares",
            title: "Por particulares",
          },
        ],
      },
      {
        slug: "desplazamiento-forzado",
        title: "Desplazamiento forzado",
        color: "#003DBC",
        subtypes: [
          {
            slug: "interno",
            title: "Interno",
          },
          {
            slug: "externo",
            title: "Externo",
          },
          {
            slug: "interno-con-violencia-de-genero",
            title: "Interno con violencia de género",
          },
          {
            slug: "externo-con-violencia-de-genero",
            title: "Externo con violencia de género",
          },
        ],
      },
      {
        slug: "intervencion-o-vigilancia-ilegal-de-comunicaciones",
        title: "Intervención o vigilancia ilegal de comunicaciones",
        color: "#FF52B8",
        subtypes: [
          {
            slug: "uso-de-malware",
            title: "Uso de malware",
          },
          {
            slug: "phishing",
            title: "Phishing",
          },
          {
            slug: "intervencion-de-cuentas",
            title: "Intervención de cuentas",
          },
          {
            slug: "suplantacion-de-identidad",
            title: "Suplantación de identidad",
          },
          {
            slug: "suplantacion-de-identidad-con-componente-de-genero",
            title: "Suplantación de identidad con componente de género",
          },
          {
            slug: "suplantacion-de-identidad-con-connotacion-sexual",
            title: "Suplantación de identidad con connotación sexual",
          },
          {
            slug: "conexion-no-autorizada-a-servidores-y-sistemas-de-redes",
            title: "Conexión no autorizada a servidores y sistemas de redes",
          },
          {
            slug: "sustraccion-de-informacion-de-naturaleza-intima-o-sexual",
            title: "Sustracción de información de naturaleza íntima o sexual",
          },
          {
            slug: "intervencion-telefonica",
            title: "Intervención telefónica",
          },
        ],
      },
      {
        slug: "intimidacion-y-hostigamiento",
        title: "Intimidación y hostigamiento",
        color: "#AF2D71",
        subtypes: [
          {
            slug: "difusion-de-informacion-sin-consentimiento",
            title: "Difusión de información sin consentimiento",
          },
          {
            slug:
              "difusion-de-informacion-intima-o-de-naturaleza-sexual-sin-consentimiento",
            title:
              "Difusión de información íntima o de naturaleza sexual sin consentimiento",
          },
          {
            slug: "difusion-de-informacion-con-componente-de-genero",
            title: "Difusión de información con componente de género",
          },
          {
            slug: "doxxing",
            title: "DOXXING",
          },
          {
            slug: "doxxing-con-componente-de-genero",
            title: "DOXXING con componente de género",
          },
          {
            slug: "doxxing-con-connotacion-sexual",
            title: "DOXXING con connotación sexual",
          },
          {
            slug: "persecucion",
            title: "Persecución",
          },
          {
            slug: "presencia-de-personas-o-grupos-armados",
            title: "Presencia de personas o grupos armados",
          },
          {
            slug: "campana-de-desprestigio",
            title: "Campaña de desprestigio",
          },
          {
            slug: "campana-de-desprestigio-con-componente-de-genero",
            title: "Campaña de desprestigio con componente de género",
          },
          {
            slug: "campana-de-desprestigio-con-connotacion-sexual",
            title: "Campaña de desprestigio con connotación sexual",
          },
          {
            slug: "maltrato-o-muerte-de-animales-domesticos-guardia-o-guia",
            title: "Maltrato o muerte de animales domésticos, guardia o guía",
          },
          {
            slug: "toma-de-videos-o-fotografias-no-autorizadas",
            title: "Toma de videos o fotografías no autorizadas",
          },
          {
            slug:
              "toma-de-videos-o-fotografias-intimas-sexuales-sin-autorizacion",
            title:
              "Toma de videos o fotografías íntimas/sexuales sin autorización",
          },
          {
            slug: "comunicaciones-intimidatorias",
            title: "Comunicaciones intimidatorias",
          },
          {
            slug: "comunicaciones-intimidatorias-con-componente-de-genero",
            title: "Comunicaciones intimidatorias con componente de género",
          },
          {
            slug: "comunicaciones-intimidatorias-con-connotacion-sexual",
            title: "Comunicaciones intimidatorias con connotación sexual",
          },
          {
            slug: "actos-intimidatorios",
            title: "Actos intimidatorios",
          },
          {
            slug: "actos-intimidatorios-con-componente-de-genero",
            title: "Actos intimidatorios con componente de género",
          },
          {
            slug: "actos-intimidatorios-con-connotacion-sexual",
            title: "Actos intimidatorios con connotación sexual",
          },
          {
            slug: "acoso",
            title: "Acoso",
          },
          {
            slug: "acoso-con-componente-de-genero",
            title: "Acoso con componente de género",
          },
          {
            slug: "acoso-con-componente-sexual",
            title: "Acoso con componente sexual",
          },
        ],
      },
      {
        slug: "privacion-de-la-libertad",
        title: "Privación de la libertad",
        color: "#FDEC23",
        subtypes: [
          {
            slug: "detencion-arbitraria",
            title: "Detención arbitraria",
          },
          {
            slug: "privacion-ilegal-de-la-libertad",
            title: "Privación ilegal de la libertad",
          },
          {
            slug: "detencion-arbitraria-con-violencia-de-genero",
            title: "Detención arbitraria con violencia de género",
          },
          {
            slug: "secuestro",
            title: "Secuestro",
          },
          {
            slug: "secuestro-con-violencia-de-genero",
            title: "Secuestro con violencia de género",
          },
        ],
      },
      {
        slug: "tortura-o-tratos-crueles-inhumanos-y-degradantes",
        title: "Tortura o tratos crueles, inhumanos y degradantes",
        color: "#006837",
        subtypes: [
          {
            slug: "tortura",
            title: "Tortura",
          },
          {
            slug: "tratos-crueles-inhumanos-y-degradantes",
            title: "Tratos crueles, inhumanos y degradantes",
          },
          {
            slug: "tortura-sexual",
            title: "Tortura sexual",
          },
        ],
      },
      {
        slug: "uso-ilegitimo-del-poder-publico",
        title: "Uso ilegítimo del poder público",
        color: "#631417",
        subtypes: [
          {
            slug: "criminalizacion",
            title: "Criminalización",
          },
          {
            slug: "criminalizacion-con-componente-de-genero",
            title: "Criminalización con componente de género",
          },
          {
            slug: "estigmatizacion-por-medio-de-comunicacion-oficial",
            title: "Estigmatización por medio de comunicación oficial",
          },
          {
            slug:
              "estigmatizacion-por-medio-de-comunicacion-oficial-con-componente-de-genero",
            title:
              "Estigmatización por medio de comunicación oficial con componente de género",
          },
          {
            slug: "hostigamiento-judicial-por-la-via-civil",
            title: "Hostigamiento judicial por la vía civil",
          },
          {
            slug: "hostigamiento-ministerial-o-judicial-por-la-via-penal",
            title: "Hostigamiento ministerial o judicial por la vía penal",
          },
          {
            slug: "hostigamiento-administrativo",
            title: "Hostigamiento administrativo",
          },
          {
            slug:
              "suspension-denegacion-o-condicionamiento-de-publicidad-oficial",
            title:
              "Suspensión, denegación o condicionamiento de publicidad oficial",
          },
          {
            slug: "filtracion-de-informacion-en-un-proceso-legal",
            title: "Filtración de información en un proceso legal",
          },
          {
            slug:
              "embargo-o-decomiso-de-propiedades-por-mandato-administrativo-o-judicial",
            title:
              "Embargo o decomiso de propiedades por mandato administrativo o judicial",
          },
        ],
      },
    ],
    stateColors: [
      {
        name: "Aguascalientes",
        color: "#fa9f69",
        alias: "AGS",
      },
      {
        name: "Baja California",
        color: "#e32980",
        alias: "BC",
      },
      {
        name: "Baja California Sur",
        color: "#cc2974",
        alias: "BCS",
      },
      {
        name: "Campeche",
        color: "#5d92e8",
        alias: "CAMP",
      },
      {
        name: "Coahuila",
        color: "#8366B5",
        alias: "COAH",
      },
      {
        name: "Colima",
        color: "#fa8f50",
        alias: "COL",
      },
      {
        name: "Chiapas",
        color: "#467edb",
        alias: "CHIS",
      },
      {
        name: "Chihuahua",
        color: "#c41e6b",
        alias: "CHIH",
      },
      {
        name: "Ciudad de México",
        color: "#cfe254",
        alias: "CDMX",
      },
      {
        name: "Durango",
        color: "#6B4D9E",
        alias: "DGO",
      },
      {
        name: "Guanajuato",
        color: "#f08648",
        alias: "GTO",
      },
      {
        name: "Guerrero",
        color: "#a7d951",
        alias: "GRO",
      },
      {
        name: "Hidalgo",
        color: "#94cf47",
        alias: "HGO",
      },
      {
        name: "Jalisco",
        color: "#e87b3a",
        alias: "JAL",
      },
      {
        name: "Estado de México",
        color: "#b7d951",
        alias: "EDOMEX",
      },
      {
        name: "Michoacán",
        color: "#e37230",
        alias: "MICH",
      },
      {
        name: "Morelos",
        color: "#7eba3d",
        alias: "MOR",
      },
      {
        name: "Nayarit",
        color: "#db6a28",
        alias: "NAY",
      },
      {
        name: "Nuevo León",
        color: "#64429e",
        alias: "NL",
      },
      {
        name: "Oaxaca",
        color: "#3670d1",
        alias: "OAX",
      },
      {
        name: "Puebla",
        color: "#65ab2b",
        alias: "PUE",
      },
      {
        name: "Querétaro",
        color: "#d16526",
        alias: "QRO",
      },
      {
        name: "Quintana Roo",
        color: "#3268c2",
        alias: "QROO",
      },
      {
        name: "San Luis Potosí",
        color: "#512f8a",
        alias: "SLP",
      },
      {
        name: "Sinaloa",
        color: "#b51c63",
        alias: "SIN",
      },
      {
        name: "Sonora",
        color: "#9e1856",
        alias: "SON",
      },
      {
        name: "Tabasco",
        color: "#3064ba",
        alias: "TAB",
      },
      {
        name: "Tamaulipas",
        color: "#462978",
        alias: "TAMPS",
      },
      {
        name: "Tlaxcala",
        color: "#48961e",
        alias: "TLAX",
      },
      {
        name: "Veracruz",
        color: "#2a4fad",
        alias: "VER",
      },
      {
        name: "Yucatán",
        color: "#2b4996",
        alias: "YUC",
      },
      {
        name: "Zacatecas",
        color: "#bf5c23",
        alias: "ZAC",
      },
    ],
  },
  mutations: {
    setStateFilter(state, value) {
      state.filters.state = value;
    },
    setMinYearFilter(state, value) {
      state.filters.minYear = value;
    },
    setMaxYearFilter(state, value) {
      state.filters.maxYear = value;
    },
    setEmptyYearFilter(state, value) {
      state.filters.emptyYear = value;
    },
    setOrderFilter(state, value) {
      state.filters.order = value;
    },
    setSearchTextFilter(state, value) {
      state.filters.searchText = value;
    },
    setTypeFilter(state, value) {
      state.filters.type = value;
    },
    setContextFilter(state, value) {
      state.filters.context = value;
    },
    setReports(state, value) {
      state.reports = value;
    },
    setContexts(state, value) {
      state.contexts = value;
    },
    setFilteredReports(state, value) {
      state.filteredReports = value;
    },
    backupReports(state, value) {
      state.bakReports = value;
    },
    backupContexts(state, value) {
      state.bakContexts = value;
    },
    setSelection(state, value) {
      state.selection = value;
    },
  },
  getters: {
    selected: (state) => {
      return state.selection;
    },
  },
  actions: {
    async getPublicReports({ state, commit }) {
      const reports = [];
      d3.csv(
        "https://s3.amazonaws.com/images.rompeelmiedo.org/Reportes.csv",
        (data) => {
          reports.push({
            source: data["Nombre"],
            media: data["Medio/Colectivo"],
            position: data["Cargo"],
            state: data["Estado"],
            municipality: data["Municipio"],
            address: data["Dirección específica"],
            date: data["Fecha"],
            year: Number(data["Año"]),
            time: data["Hora"],
            type: data["Tipo de agresión"],
            details: data["Agresión específica"],
            facts: data["Hechos"],
            verification_datetime: data["Día y hora de verificación "],
            alert_a19: data["Alerta de A19"],
            uploaded_to_map: data["Subido a mapa"],
            displayed_in_post: data["Montado a postal"],
            folio: data["Folio"],
            version: data["Versión"],
            count: data["Número de agresiones a contabilizar"],
            place: data["Lugar"],
            lat: data["Latitud"] !== "" ? parseFloat(data["Latitud"]) : "",
            lng: data["Longitud"] !== "" ? parseFloat(data["Longitud"]) : "",
            marker: data["Latitud"] && data["Longitud"]
              ? [parseFloat(data["Latitud"]), parseFloat(data["Longitud"])]
              : [],
            perpetrator: data["Perpetrador"],
            context: data["Contexto"],
            contextId: data["IdContexto"],
          });
        }
      ).then(() => {
        commit("setReports", reports);
        commit("backupReports", reports);
      });
    },
    async getContexts({ state, commit }) {
      const contexts = [];
      d3.csv(
        "https://s3.amazonaws.com/images.rompeelmiedo.org/Contexts.csv",
        (data) => {
          contexts.push({
            context: data["Contexto"],
            contextId: data["IdContexto"],
            color: data["Color"],
          });
        }
      ).then(() => {
        commit("setContexts", contexts);
        commit("backupContexts", contexts);
      });
    },
    filterReports({ state, commit }) {
      let filteredReports = state.bakReports;
      if (state.filters.type) {
        filteredReports = filteredReports.filter((report) => {
          return report.type === state.filters.type;
        });
      }
      if (state.filters.context) {
        filteredReports = filteredReports.filter((report) => {
          return report.context === state.filters.context;
        });
      }

      if (state.filters.state) {
        filteredReports = filteredReports.filter((report) => {
          if (state.filters.state === "Ciudad de México") {
            return (
              report.state === "Ciudad de México" || report.state === "CDMX"
            );
          }
          return report.state === state.filters.state;
        });
      }

      if (
        state.filters.minYear &&
        state.filters.minYear !== "" &&
        state.filters.maxYear &&
        state.filters.maxYear !== ""
      ) {
        filteredReports = filteredReports.filter((report) => {
          if (report.year) {
            return (
              report.year >= state.filters.minYear &&
              report.year <= state.filters.maxYear
            );
          }
        });
      } else if (state.filters.minYear && state.filters.minYear !== "") {
        filteredReports = filteredReports.filter((report) => {
          if (state.filters.minYear === "No especificado") {
            return !report.year == true;
          } else {
            return report.year >= state.filters.minYear;
          }
        });
      } else if (state.filters.maxYear && state.filters.maxYear !== "") {
        filteredReports = filteredReports.filter((report) => {
          if (state.filters.maxYear === "No especificado") {
            return !report.year == true;
          } else {
            return report.year <= state.filters.maxYear;
          }
        });
      }

      if (state.filters.searchText) {
        filteredReports = filteredReports.filter((report) => {
          var replace = state.filters.searchText;
          var re = new RegExp(replace, "i");
          var result = report.facts.match(re);
          if (result) {
            return true;
          } else {
            return false;
          }
        });
      }

      if (state.filters.order) {
        if (state.filters.order === "Estados") {
          // Order by estados
          filteredReports = filteredReports.sort((a, b) => {
            if (a.state > b.state) {
              return 1;
            } else if (a.state < b.state) {
              return -1;
            } else {
              if (a.municipality > b.municipality) {
                return 1;
              }
              if (a.municipality < b.municipality) {
                return -1;
              }
              return 0;
            }
          });
        }

        if (
          state.filters.order === "Más reciente" ||
          state.filters.order === "Más antiguas"
        ) {
          // Más reciente || Más antiguo
          // Default más antiguas
          var sign1 = 1;
          var sign2 = -1;

          if (state.filters.order === "Más reciente") {
            sign1 = -1;
            sign2 = 1;
          }

          filteredReports = filteredReports.sort((a, b) => {
            if (parseInt(a.folio) > parseInt(b.folio)) {
              return sign1;
            }
            if (parseInt(b.folio) > parseInt(a.folio)) {
              return sign2;
            }
            return 0;
          });
        }
      }
      commit("setReports", filteredReports);
      //commit("setFilteredReports", filteredReports);
      commit("setSelection", undefined);
    },
  },
});
